import Modal from "./Modal";
import modal_reducer from "./slice";
export { openModal, closeModal } from "./slice";
export type { ModalState } from "./slice";
export { modal_reducer };
export default Modal;
